<div id="printContent" #printContent>
  <wf-page-tour [steps]="tourSteps"></wf-page-tour>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="filterSchoolTeacher()"
    ></wf-school-teacher-filter>
  </div>
  <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
      </h3>

      @if (!currentUser!.isTeacherReviewUser()) {
        <button id="print-button" class="btn print-summary-button print-hide" (click)="printReport()">
          <fa-icon [icon]="printIcon"></fa-icon>
          Print Results
        </button>
      }
  </div>
  <div>
    <div class="report-section-header split-flex">
      <h5 class="results-report-header"><fa-icon [classes]="['print-hide']" [icon]="objectiveIcon"></fa-icon> Objective Pre/Post</h5>
      <div class="button-group">
        <div *ngIf="showCoTeacherFilter" class="form-check">
          <input id="coteacher-checkbox" class="form-check-input" type="checkbox" [(ngModel)]="hideSharedStudents" (change)="toggleSharedStudents()">
          <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
        </div>
      </div>
    </div>
    <div class="objective-prepost-container">
      <div id="student-message" class="alert message" *ngIf="message" [ngClass]="{ 'alert-danger': messageStatus === 'error', 'alert-warning' : messageStatus === 'warning' }">
        <div class="icon">
          <fa-icon [icon]="warningIcon" *ngIf="messageStatus === 'warning'"></fa-icon>
          <fa-icon [icon]="errorIcon" *ngIf="messageStatus === 'error'"></fa-icon>
        </div>
        <div>
          <div class="bold">{{ messageTitle }}</div>
          {{ message }}
        </div>
      </div>
      <div class="student-dropdown-row justify-content-end">
        <label for="student-dropdown">Student</label>
        <select id="student-dropdown" class="form-select print-hide width-50" [(ngModel)]="selectedStudent" (change)="updateStudent()">
          <option *ngFor="let student of students; trackBy: trackByStudentId" [ngValue]="student">{{ student.firstName }} {{ student.lastName }}</option>
        </select>
        <div class="print-show">{{selectedStudent?.firstName || ''}} {{selectedStudent?.lastName || ''}}</div>
      </div>
      <table class="table table-borderless student-table">
        <thead class="student-table-header">
          <th>First Name</th>
          <th>Last Name</th>
          <th>Grade</th>
        </thead>
        <tbody>
          <tr>
            <td>{{selectedStudent?.firstName}}</td>
            <td>{{selectedStudent?.lastName}}</td>
            <td>{{selectedStudent?.grade | displayGrade }}</td>
          </tr>
        </tbody>
      </table>
      @if (!selectedObjective) {
        <div class="no-data-label">
          No Data for this Student...
        </div>
      } @else {
        <div class="objective-prepost-chart-container">
          <div class="objective-chart-container">
            <div class="objective-header-div">
              <div class="objective-chart-header">Objective Performance</div>
              <div id="objective-dropdown-wrapper" class="flex align-items-center gap-2">
                <label for="objective-dropdown">Objective</label>
                <select class="form-select print-hide" id="objective-dropdown" [(ngModel)]="selectedObjective" (change)="updateObjectiveChart()">
                  @for (objective of objectives() | keyvalue ; track objective.value.objectiveNumber) {
                    <option [ngValue]="objective.value">{{ objective.value.objectiveText }}</option>
                  }
                </select>
              </div>
              <div class="print-show">{{selectedObjective.objectiveText || ''}}</div>
            </div>
            <div class="objective-chart-area">
              <div class="flex align-items-center justify-content-between">
                <div class="date-label">Dates: {{ selectedObjective.formattedStartDate }} to {{ selectedObjective.formattedEndDate }}</div>
                <div class="objective-chart-legend">
                  <div><div class="legend-box pretest-objective"></div><div class="legend-label">Pretest</div></div>
                  <div><div class="legend-box posttest-objective"></div><div class="legend-label">Posttest</div></div>
                </div>
              </div>
              <div class="print-hide chart-container">
                <canvas #objectiveChartCanvas
                        id="objective-chart"
                        baseChart
                        [data]="objectiveChartData"
                        [type]="chartType"
                        [options]="chartOpts"
                        [plugins]="chartPlugins"
                ></canvas>
              </div>
              <img #objectiveChartImg id="objective-chart-img" class="chart-img" />
            </div>
          </div>
          <div class="objective-growth-chart-container">
            <div class="objective-growth-header-div">
              <div class="objective-chart-header">Growth in a Category Across Objectives</div>
              <div id="objective-growth-dropdown-wrapper" class="flex align-items-center gap-2">
                <label for="objective-growth-dropdown">Category</label>
                <select class="form-select print-hide" id="objective-growth-dropdown" [(ngModel)]="selectedCategory" (change)="updateObjectiveGrowthChart()">
                  @for (category of growthCategories ; track category.value) {
                    <option [ngValue]="category">{{ category.label }}</option>
                  }
                </select>
              </div>
            </div>
            <div class="objective-chart-area">
              <div class="float-end margin-right-25 objective-growth-chart-legend">
                <div><div class="legend-box pretest-objective-growth"></div><div class="legend-label">Pretest</div></div>
                <div><div class="legend-box posttest-objective-growth"></div><div class="legend-label">Posttest</div></div>
              </div>
              <div class="print-hide chart-container">
                <canvas #objectiveGrowthChartCanvas
                        id="objective-growth-chart"
                        baseChart
                        [data]="objectiveGrowthChartData()"
                        [type]="chartType"
                        [options]="growthChartOpts"></canvas>
              </div>
              <img #objectiveGrowthChartImg id="objective-growth-chart-img" class="chart-img" />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
